module.exports = __webpack_public_path__ + "img/4.407ea5a1.png";